import { INDENTS } from 'vars/index'

export const BannerDescriptionDirection = {
  Row: 'row',
  Column: 'column',
} as const
export type BannerDescriptionDirection =
  (typeof BannerDescriptionDirection)[keyof typeof BannerDescriptionDirection]

export const BannerDescriptionAlignItems = {
  FlexStart: 'flex-start',
  Center: 'center',
  FlexEnd: 'flex-end',
} as const
export type BannerDescriptionAlignItems =
  (typeof BannerDescriptionAlignItems)[keyof typeof BannerDescriptionAlignItems]

export const BannerDescriptionColumnGap = {
  INDENT_0: INDENTS.INDENT_0,
  INDENT_20: INDENTS.INDENT_20,
  INDENT_40: INDENTS.INDENT_40,
  INDENT_60: INDENTS.INDENT_60,
  INDENT_80: INDENTS.INDENT_80,
} as const
export type BannerDescriptionColumnGap =
  (typeof BannerDescriptionColumnGap)[keyof typeof BannerDescriptionColumnGap]

export const BannerDescriptionRowGap = {
  INDENT_0: INDENTS.INDENT_0,
  INDENT_20: INDENTS.INDENT_20,
  INDENT_40: INDENTS.INDENT_40,
  INDENT_50: INDENTS.INDENT_50,
  INDENT_60: INDENTS.INDENT_60,
  INDENT_80: INDENTS.INDENT_80,
} as const
export type BannerDescriptionRowGap =
  (typeof BannerDescriptionRowGap)[keyof typeof BannerDescriptionRowGap]
